/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PartialParentRole } from './PartialParentRole';
import {
    PartialParentRoleFromJSON,
    PartialParentRoleFromJSONTyped,
    PartialParentRoleToJSON,
} from './PartialParentRole';

/**
 * 
 * @export
 * @interface ParentRole
 */
export interface ParentRole {
    /**
     * 
     * @type {string}
     * @memberof ParentRole
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ParentRole
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ParentRole
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the ParentRole interface.
 */
export function instanceOfParentRole(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ParentRoleFromJSON(json: any): ParentRole {
    return ParentRoleFromJSONTyped(json, false);
}

export function ParentRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function ParentRoleToJSON(value?: ParentRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
        'enabled': value.enabled,
    };
}

